import React from "react";
import { Table, Text } from "@mantine/core";

const SubledgerReconciliationView = ({ reports = [] }) => (
  <>
    <Table striped withBorder>
      <thead>
        <tr>
          <th>Subledger</th>
          <th>Control Account</th>
          <th>Subledger Balance</th>
          <th>GL Balance</th>
          <th>Difference</th>
        </tr>
      </thead>
      <tbody>
        {reports.map((row) => (
          <tr key={row.type}>
            <td>{row.type}</td>
            <td>{row.accountCode}</td>
            <td>{row.subledgerBalance}</td>
            <td>{row.glBalance}</td>
            <td>{row.difference}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    {reports.length === 0 && (
      <Text size="sm" color="dimmed" mt="md">
        No reconciliation data yet.
      </Text>
    )}
  </>
);

export default SubledgerReconciliationView;
